import React, { useState } from "react";

const FAQAccordion = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="accordion-wrap">
            {faqData.map((item, index) => (
                <div key={index} className="accordion-item">
                    <h2 className="accordion-header">
                        <button
                            className={`accordion-button ${openIndex === index ? "active" : ""}`}
                            onClick={() => toggleAccordion(index)}
                            aria-expanded={openIndex === index}
                        >
                            {item.question}
                        </button>
                    </h2>
                    <div
                        className={`accordion-content ${openIndex === index ? "open" : ""}`}
                    >
                        <div className="accordion-body">{item.answer}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

const faqData = [
    {
        question: "How can I buy a flat in Ahmedabad with Luxrock Realty?",
        answer:
            "First we understand your budget, preferred location and property type. Our real estate consultants shortlist suitable flats or plots in Ahmedabad, arrange site visits, help in price negotiation and handle complete documentation until the property is registered in your name."
    },
    {
        question: "How can I sell my property through Luxrock Realty?",
        answer:
            "We evaluate your property value, suggest the right selling price, promote it to potential buyers and manage negotiations, documentation and the final sale process smoothly."
    },
    {
        question: "Do you help investors with financing for industrial land or commercial properties?",
        answer:
            "Yes, we assist investors with financing solutions for industrial land and commercial property investments through our trusted financial partners."
    },
    {
        question: "Do you provide legal documentation services?",
        answer:
            "Yes, we offer complete legal support including agreement drafting, title verification, registration assistance and professional legal advisory."
    },
    {
        question: "Why choose Luxrock Realty?",
        answer:
            "Luxrock Realty provides verified properties, transparent transactions and professional guidance. Our goal is to make property buying and selling simple, safe and stress-free."
    },
    {
        question: "What is your brokerage fee?",
        answer:
            "Brokerage depends on the property type and transaction value. We maintain clear and transparent pricing with no hidden charges."
    },
    {
        question: "What is the better option: luxury apartments or plots?",
        answer:
            "Luxury apartments provide ready-to-move comfort and amenities, while plots offer flexibility and higher long-term appreciation. The right choice depends on your investment goal."
    },
    {
        question: "Is Ahmedabad a good city for real estate investment?",
        answer:
            "Yes, Ahmedabad is one of the fastest growing real estate markets with strong opportunities in luxury apartments, commercial properties and industrial land investments."
    },
    {
        question: "Do you help with property registration?",
        answer:
            "Yes, we handle the complete registration process including documentation and legal formalities."
    }
];
;

export default FAQAccordion;
